import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import BasePage from "@Scripts/Pages/BasePage";

export default class WorkWithUsPage extends BasePage {
    public static async init() {
        await super.init();

        this.expandingJobOfferDescription();
        this.setJobOffer();
    }

    private static expandingJobOfferDescription() {
        var $item = $(".app-position-list .item");
        var url = window.location.href;
        var id = url.indexOf("#") != -1 ? url.substring(url.indexOf("#") + 1) : "";

        if (id) {
            $(".job-offer-description", $("#" + id)).show();
            $("#" + id).addClass("active");
        }

        $(".expbutton", $item).click(function () {
            var $itemCurrent = $(this).parent();

            $(".job-offer-description", $item).not($(".job-offer-description", $itemCurrent)).slideUp();
            $($item).not($($itemCurrent)).removeClass("active");

            $(".job-offer-description", $itemCurrent).slideToggle();
            $($itemCurrent).toggleClass("active");
        });
    }

    private static setJobOffer() {
        var $items = $(".app-position-list .item");
        $(".candidacy", $items).bind("click", function () {
            var $itemCurrent = $(this).parent().parent().parent().parent();

            (<any>window).App.instances.vm.$store.commit("workWithUsStore/setJobOfferCode", $(".code", $itemCurrent).text() + " - " + $(".job-offer-title", $itemCurrent).text());

            GTagHelper.sendEvent("click", "work_with_us", "go_to_form");
        });

        $(".document", $items).bind("click", function () {
            var $itemCurrent = $(this).parent().parent().parent();
            var fileName = $(this).attr("data-name");
            GTagHelper.sendEvent("file_download", "work_with_us", $(".job-offer-title", $itemCurrent).text());
        })
    }
}